export default "__VITE_ASSET__CverOZtI__"